import { Reveal, Eyebrow } from "@/components/site/Motion";

const H2 = "font-display mt-6 text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl";

export const Tags = ({ items, dark = false }) => (
  <ul className="flex flex-wrap gap-2">
    {items.map((t) => (
      <li
        key={t}
        className={`border px-3.5 py-2 text-sm transition-colors duration-300 hover:border-[#D4AF37] ${dark ? "border-white/20 text-white" : "border-[#D9E6E4] bg-white text-[#0F3D39]"}`}
      >
        {t}
      </li>
    ))}
  </ul>
);

export const Approach = ({ eyebrow = "Our Approach", title, paras = [] }) => (
  <section className="mx-auto grid max-w-[1400px] gap-10 px-6 py-24 lg:grid-cols-12 lg:px-12 lg:py-32" data-testid="solution-approach">
    <Reveal className="lg:col-span-4">
      <Eyebrow>{eyebrow}</Eyebrow>
    </Reveal>
    <Reveal delay={0.1} className="lg:col-span-8">
      <h2 className={`${H2} mt-0 text-[#0D9488]`}>{title}</h2>
      <div className="mt-8 space-y-5">
        {paras.map((p) => (
          <p key={p} className="text-base leading-relaxed text-[#2D6A64] md:text-lg">{p}</p>
        ))}
      </div>
    </Reveal>
  </section>
);

const Offering = ({ o, i }) => (
  <Reveal>
    <article className="grid gap-8 border-t border-[#D9E6E4] py-12 transition-colors duration-500 hover:border-[#D4AF37] lg:grid-cols-12 lg:py-16" data-testid={`offering-${i}`}>
      <div className="lg:col-span-5">
        <span className="font-display flex items-center gap-3 text-xs font-bold uppercase tracking-[0.25em] text-[#0D9488]">
          <span className="h-2 w-2 rotate-45 bg-[#D4AF37]" />0{i + 1} · {o.name}
        </span>
        <h3 className="font-display mt-5 text-2xl font-bold tracking-tight text-[#0D9488] lg:text-3xl">{o.headline}</h3>
      </div>
      <div className="space-y-5 lg:col-span-7">
        {o.paras.map((p) => (
          <p key={p} className="text-base leading-relaxed text-[#2D6A64] md:text-lg">{p}</p>
        ))}
        {o.tags && <div className="pt-2"><Tags items={o.tags} /></div>}
        {o.note && <p className="text-sm italic text-[#2D6A64]">{o.note}</p>}
      </div>
    </article>
  </Reveal>
);

export const Offerings = ({ eyebrow = "What We Offer", title, items = [] }) => (
  <section className="border-y border-[#E2ECEB] bg-[#F4F9F8]" data-testid="solution-offerings">
    <div className="mx-auto max-w-[1400px] px-6 py-24 lg:px-12 lg:py-32">
      <Reveal>
        <Eyebrow>{eyebrow}</Eyebrow>
        <h2 className={`${H2} text-[#0D9488]`}>{title}</h2>
      </Reveal>
      <div className="mt-16">
        {items.map((o, i) => (
          <Offering key={o.name} o={o} i={i} />
        ))}
      </div>
    </div>
  </section>
);

export const Statement = ({ eyebrow, title, lines = [], paras = [], tags, emphasis = [] }) => (
  <section className="relative overflow-hidden bg-[#074E48] text-white grain" data-testid="solution-statement">
    <div className="relative mx-auto grid max-w-[1400px] gap-12 px-6 py-24 lg:grid-cols-12 lg:px-12 lg:py-36">
      <Reveal className="lg:col-span-6">
        {eyebrow && <Eyebrow light>{eyebrow}</Eyebrow>}
        <h2 className={H2}>{title}</h2>
      </Reveal>
      <Reveal delay={0.1} className="space-y-6 lg:col-span-6">
        {lines.length > 0 && (
          <div className="space-y-2 border-l border-[#D4AF37] pl-6">
            {lines.map((l) => (
              <p key={l} className="font-display text-xl font-medium lg:text-2xl">{l}</p>
            ))}
          </div>
        )}
        {paras.map((p) => (
          <p key={p} className="text-base leading-relaxed text-[#CFE7E3] md:text-lg">{p}</p>
        ))}
        {tags && <Tags items={tags} dark />}
        {emphasis.length > 0 && (
          <div className="space-y-1 pt-4">
            {emphasis.map((e) => (
              <p key={e} className="font-display text-xl font-semibold text-[#F7EFD2] lg:text-2xl">{e}</p>
            ))}
          </div>
        )}
      </Reveal>
    </div>
  </section>
);
